import { useCallback, useEffect, useState } from "react";

import campaignService from "core/services/apiServices/campaignService";

const useMobileUrls = (campaignId) => {

    const [ loading, setLoading ] = useState(false);

    const [ urls, setUrls ] = useState([]);

    const getMobileUrls = useCallback( () => {
        setLoading(true);
        let params = {
            campaignId
        };

        campaignService.getMobileUrls(params).
            then(data => {
                setUrls(
                    data.map(d => ({
                        id: d
                    }))
                );                
            }).
            finally(() => {
                setLoading(false)
            })
    }, [campaignId])

    const addMobileUrl = useCallback(urls  => {
        const dataToAdd = urls.map(u => ({
            id: u
        }))
        setUrls(prevState => ([
            ...dataToAdd,
            ...prevState
        ]))
    }, [campaignId])

    const removeMobileUrl = useCallback( id => {
        setUrls(prevState => (
            prevState.filter(l => l.id !== id)
        ))
    }, [campaignId])

    useEffect(() => {
        getMobileUrls()
    }, [ campaignId])


    return {
        loading,
        urls,
        getMobileUrls,
        addMobileUrl,
        removeMobileUrl,
    }
}

export default useMobileUrls;